/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MedicareComponentEstimate } from './MedicareComponentEstimate';
import {
    MedicareComponentEstimateFromJSON,
    MedicareComponentEstimateFromJSONTyped,
    MedicareComponentEstimateToJSON,
} from './MedicareComponentEstimate';

/**
 * 
 * @export
 * @interface MedicareEstimates
 */
export interface MedicareEstimates {
    /**
     * 
     * @type {Array<MedicareComponentEstimate>}
     * @memberof MedicareEstimates
     */
    estimates: Array<MedicareComponentEstimate>;
    /**
     * 
     * @type {number}
     * @memberof MedicareEstimates
     */
    unadjusted_total: number;
    /**
     * 
     * @type {number}
     * @memberof MedicareEstimates
     */
    adjusted_total: number;
    /**
     * 
     * @type {string}
     * @memberof MedicareEstimates
     */
    hipps_code?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MedicareEstimates
     */
    days_1_3_rate?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MedicareEstimates
     */
    days_4_100_rate?: number | null;
}

/**
 * Check if a given object implements the MedicareEstimates interface.
 */
export function instanceOfMedicareEstimates(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "estimates" in value;
    isInstance = isInstance && "unadjusted_total" in value;
    isInstance = isInstance && "adjusted_total" in value;

    return isInstance;
}

export function MedicareEstimatesFromJSON(json: any): MedicareEstimates {
    return MedicareEstimatesFromJSONTyped(json, false);
}

export function MedicareEstimatesFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicareEstimates {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'estimates': ((json['estimates'] as Array<any>).map(MedicareComponentEstimateFromJSON)),
        'unadjusted_total': json['unadjusted_total'],
        'adjusted_total': json['adjusted_total'],
        'hipps_code': !exists(json, 'hipps_code') ? undefined : json['hipps_code'],
        'days_1_3_rate': !exists(json, 'days_1_3_rate') ? undefined : json['days_1_3_rate'],
        'days_4_100_rate': !exists(json, 'days_4_100_rate') ? undefined : json['days_4_100_rate'],
    };
}

export function MedicareEstimatesToJSON(value?: MedicareEstimates | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'estimates': ((value.estimates as Array<any>).map(MedicareComponentEstimateToJSON)),
        'unadjusted_total': value.unadjusted_total,
        'adjusted_total': value.adjusted_total,
        'hipps_code': value.hipps_code,
        'days_1_3_rate': value.days_1_3_rate,
        'days_4_100_rate': value.days_4_100_rate,
    };
}

